const Chromosome = function (name, order, bpStart, bpLength, rangeLocus) {
    this.name = name
    this.order = order
    this.bpStart = bpStart
    this.bpLength = bpLength
    this.rangeLocus = rangeLocus
}

export default Chromosome